import type { Template } from "@/types";

export const PO_06_H2_V4: Template[] = [
    {
        id: "po-06-h2v4-01",
        name: "PO 01 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 48, y: 219, width: 257, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 313, y: 219, width: 282, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 313, y: 417, width: 282, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 698, y: 158, width: 361, height: 510, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1067, y: 158, width: 178, height: 251, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1067, y: 417, width: 178, height: 251, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-02",
        name: "PO 02 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 143, y: 158, width: 365, height: 510, rotation: 0, imageRotation: 0 },
            { id: "2", x: 710, y: 158, width: 391, height: 251, rotation: 0, imageRotation: 0 },
            { id: "3", x: 710, y: 418, width: 391, height: 251, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1109, y: 158, width: 118, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1109, y: 332, width: 118, height: 165, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1109, y: 504, width: 118, height: 165, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-03",
        name: "PO 03 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 51, y: 219, width: 271, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 219, width: 271, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 418, width: 271, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 219, width: 278, height: 391, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1048, y: 219, width: 135, height: 192, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1048, y: 418, width: 135, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-04",
        name: "PO 04 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 67, y: 87, width: 515, height: 323, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 417, width: 515, height: 323, rotation: 0, imageRotation: 0 },
            { id: "3", x: 716, y: 87, width: 254, height: 323, rotation: 0, imageRotation: 0 },
            { id: "4", x: 716, y: 417, width: 254, height: 323, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 87, width: 253, height: 323, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 417, width: 253, height: 323, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-05",
        name: "PO 05 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 67, y: 87, width: 254, height: 323, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 87, width: 254, height: 323, rotation: 0, imageRotation: 0 },
            { id: "3", x: 67, y: 417, width: 516, height: 323, rotation: 0, imageRotation: 0 },
            { id: "4", x: 716, y: 87, width: 515, height: 323, rotation: 0, imageRotation: 0 },
            { id: "5", x: 716, y: 417, width: 254, height: 323, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 417, width: 253, height: 323, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-06",
        name: "PO 06 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 53, y: 154, width: 542, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 490, width: 131, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 191, y: 490, width: 131, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 329, y: 490, width: 130, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 465, y: 490, width: 130, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 700, y: 238, width: 547, height: 353, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-07",
        name: "PO 07 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 54, y: 153, width: 176, height: 257, rotation: 0, imageRotation: 0 },
            { id: "2", x: 238, y: 153, width: 359, height: 257, rotation: 0, imageRotation: 0 },
            { id: "3", x: 54, y: 417, width: 176, height: 257, rotation: 0, imageRotation: 0 },
            { id: "4", x: 238, y: 417, width: 175, height: 257, rotation: 0, imageRotation: 0 },
            { id: "5", x: 421, y: 417, width: 175, height: 257, rotation: 0, imageRotation: 0 },
            { id: "6", x: 700, y: 238, width: 547, height: 353, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-08",
        name: "PO 08 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 649, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 718, y: 161, width: 382, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 718, y: 417, width: 382, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1107, y: 161, width: 114, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1107, y: 333, width: 114, height: 164, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1107, y: 503, width: 114, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-09",
        name: "PO 09 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 53, y: 264, width: 112, height: 146, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 417, width: 112, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 173, y: 264, width: 112, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 173, y: 417, width: 112, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 292, y: 264, width: 474, height: 300, rotation: 0, imageRotation: 0 },
            { id: "6", x: 773, y: 264, width: 474, height: 300, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-10",
        name: "PO 10 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 224, width: 515, height: 379, rotation: 0, imageRotation: 0 },
            { id: "2", x: 523, y: 224, width: 122, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 523, y: 417, width: 122, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 224, width: 122, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 653, y: 417, width: 122, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 783, y: 224, width: 515, height: 379, rotation: 0, imageRotation: 0 }
        ],
    }
];